<template>
  <div class="ap-field">
    <label>{{ label }} <span v-if="required" class="ap-req">*</span></label>
    <textarea
      :value="value"
      :rows="rows"
      :placeholder="placeholder"
      class="ap-textarea"
      @input="onInput($event)"
    />
    <span v-if="hint" class="ap-hint">{{ hint }}</span>
  </div>
</template>

<script>
export default {
  name: 'TextareaInput',
  props: {
    value: { type: String, default: '' },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    rows: { type: Number, default: 3 },
    required: { type: Boolean, default: false },
    hint: { type: String, default: '' },
    uppercase: { type: Boolean, default: false }
  },
  methods: {
    onInput (e) {
      const val = this.uppercase ? e.target.value.toUpperCase() : e.target.value
      if (this.uppercase) e.target.value = val
      this.$emit('input', val)
    }
  }
}
</script>
